import { useDispatch, useSelector } from "react-redux";
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { changeFilter } from "../slice/PowerTypeFilterSlice";
import { useEffect, useState } from "react";
import { applyFleetOrNonFleetFilter } from "../slice/StationListSlice";

const FacilityTypeFilter = () => {
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState('all');
    const { selectedFacility } = useSelector(state => state.stationList);
    const countryData = useSelector((state) => state.country.data.data);
    const userData = useSelector((state) => state.user.data.data);

    const changeHandler = (e) => {
        setSelectedFilter(e.target.value);
    };

    useEffect(() => {
        let value = false;
        if (selectedFacility?.name === "All") {
            if (selectedFilter === "all") {
                value = selectedFacility?.all
            }
            else if (selectedFilter === "fleet") {
                value = selectedFacility?.fleet
            }
            else {
                value = selectedFacility?.nonFleet
            }
            if (JSON.stringify(selectedFacility?.id) !== JSON.stringify(value)) {
                dispatch(applyFleetOrNonFleetFilter(value));
            }
        }
    }, [selectedFacility, selectedFilter])

    return (
        <>
            {
                countryData?.find(item => userData?.country === item?.name)?.is_facility_type_filter_enabled ?
                    <Grid container>
                        <FormControl sx={{ minWidth: "150px" }}>
                            <InputLabel id="month-select-label">Select Facility Type </InputLabel>
                            <Select
                                labelId="month-select-label"
                                label="Select Facility Type "
                                value={selectedFilter}
                                disabled={selectedFacility?.name !== "All"}
                                onChange={changeHandler}
                                sx={{ height: "49px", backgroundColor: "white" }}
                                style={{ fontSize: "15px" }}
                            >
                                <MenuItem key={0} value={'all'} sx={{ fontSize: "15px" }}>
                                    All
                                </MenuItem>
                                <MenuItem key={1} value={'fleet'} sx={{ fontSize: "15px" }}>
                                    Fleet
                                </MenuItem>
                                <MenuItem key={2} value={'nonFleet'} sx={{ fontSize: "15px" }}>
                                    Non - Fleet
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    :
                    <></>
            }
        </>
    );
};
export default FacilityTypeFilter;